import React from "react";
import SessionStore from "../../stores/SessionStore";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import {Route} from "react-router-dom";
import PrivateWrapperContainer from "../wrappers/PrivateWrapperContainer";
import PropTypes from "prop-types";
import LoginContainer from "../containers/LoginContainer";
import PublicWrapper from "../wrappers/PublicWrapper";


const PrivateOrLoginRoute = ({component: Component, redirectRoute, appNavigator,  ...rest}) => {
    class PrivateRedirectWrapper extends React.Component {

        static propTypes = {
            usesDefaultFooter: PropTypes.bool.isRequired
        };

        static defaultProps = {
            usesDefaultFooter: true
        };

        constructor(props) {
            super(props);
            this.state = {
                "sessionState": SessionStore.getState()
            };
        }

        componentDidMount() {
            this.sessionStoreSubscriber =
                EventPublisher.subscribe(StoreUpdateEvents.SESSION_STORE_UPDATED, this.handleStoreUpdate);
        }

        componentWillUnmount() {
            EventPublisher.unsubscribe(this.sessionStoreSubscriber);
        }

        handleStoreUpdate = (topic, data) => {
            this.setState({
                "sessionState": SessionStore.getState()
            });
        };

        render() {
            if (this.state.sessionState.isAuthenticated()) {
                return (
                    <PrivateWrapperContainer usesDefaultFooter={this.props.usesDefaultFooter}>
                        <Component appNavigator={appNavigator} {...this.props}/>
                    </PrivateWrapperContainer>
                );
            }
            return (
                <PublicWrapper usesDefaultFooter={this.props.usesDefaultFooter}>
                    <LoginContainer />
                </PublicWrapper>
            );
        }
    }
    return (<Route {...rest} render={(routeProps) => <PrivateRedirectWrapper {...routeProps} {...rest}/>}/>);
};

export default PrivateOrLoginRoute;